/**
 * 361 Sleep — Section 13
 * Mobile snap carousel arrows + desktop staggered card reveal.
 */
(function () {
  'use strict';

  var BOOTED = false;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function whenGsap(fn) {
    if (window.gsap && window.ScrollTrigger) {
      fn(window.gsap, window.ScrollTrigger);
      return;
    }
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (window.gsap && window.ScrollTrigger) {
        clearInterval(timer);
        fn(window.gsap, window.ScrollTrigger);
      } else if (tries > 80) {
        clearInterval(timer);
      }
    }, 50);
  }

  function initCarousel(section) {
    var track = section.querySelector('[data-benefits-track]');
    var prev = section.querySelector('[data-benefits-prev]');
    var next = section.querySelector('[data-benefits-next]');
    if (!track || !prev || !next) return;

    function step() {
      var card = track.querySelector('[data-benefits-card]');
      if (!card) return track.clientWidth;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function syncButtons() {
      var max = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });

    next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', syncButtons, { passive: true });
    window.addEventListener('resize', syncButtons);
    syncButtons();
  }

  function initReveal(section, gsap, ScrollTrigger) {
    var cards = section.querySelectorAll('[data-benefits-card]');
    if (!cards.length) return;

    if (section._benefits361Ctx) {
      section._benefits361Ctx.revert();
      section._benefits361Ctx = null;
    }

    var ctx = gsap.context(function () {
      var mm = gsap.matchMedia();

      /* Cards scroll horizontally below 990px, so only animate the grid */
      mm.add('(min-width: 990px) and (prefers-reduced-motion: no-preference)', function () {
        gsap.from(cards, {
          opacity: 0,
          y: 42,
          duration: 0.8,
          ease: 'power2.out',
          stagger: 0.1,
          scrollTrigger: {
            trigger: section,
            start: 'top 80%',
            toggleActions: 'play none none none'
          }
        });
      });
    }, section);

    section._benefits361Ctx = ctx;
  }

  function boot() {
    document.querySelectorAll('[data-benefits361]').forEach(function (section) {
      initCarousel(section);
    });

    whenGsap(function (gsap, ScrollTrigger) {
      gsap.registerPlugin(ScrollTrigger);
      document.querySelectorAll('[data-benefits361]').forEach(function (section) {
        initReveal(section, gsap, ScrollTrigger);
      });

      if (!BOOTED) {
        BOOTED = true;
        window.addEventListener(
          'load',
          function () {
            ScrollTrigger.refresh();
          },
          { once: true }
        );
      }
    });
  }

  ready(boot);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target;
    if (!root || !root.querySelector) return;
    if (!root.querySelector('[data-benefits361]') && !(root.matches && root.matches('[data-benefits361]'))) {
      return;
    }
    boot();
  });
})();
